export default __webpack_public_path__ + "static/media/co.0583d4c2.svg";